// P1.7 — shared "which client/workspace is currently selected" state.
//
// Factored out of useBrandContext.js's own client-loading logic (byte-
// identical behavior: clientsAPI.list() populates the list, first client
// selected by default) so pages that need workspace selection but not
// useBrandContext's entity-type/entity drill-down -- Signals/
// Recommendations/Action Plans are workspace-wide overviews, not
// per-entity views like OpportunityPortfolioPage -- can reuse the exact
// same mechanism without an unnecessary entities fetch. useBrandContext()
// itself now composes this same hook for its own workspace half, so its
// external return shape and behavior for its existing consumers are
// unchanged.
//
// The selected workspaceId always comes from this authenticated, server-
// verified list -- never trusted from a URL parameter (same rule
// useBrandContext.js documents).

import { useState, useEffect } from 'react';
import { clientsAPI } from '@/lib/api';

export function useWorkspaceSelection() {
  const [clients, setClients] = useState([]);
  const [workspaceId, setWorkspaceId] = useState('');
  const [loadingClients, setLoadingClients] = useState(true);

  useEffect(() => {
    clientsAPI.list()
      .then((r) => {
        setClients(r.data || []);
        if ((r.data || []).length > 0) setWorkspaceId(r.data[0].id);
      })
      .catch(() => {})
      .finally(() => setLoadingClients(false));
  }, []);

  return { clients, workspaceId, setWorkspaceId, loadingClients };
}
